import { BaseService } from './base.service';
import { Injector, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductParamService extends BaseService {

  constructor(
    protected injector: Injector
  ) {
    super(injector);
    this.setBaseCollection('product-params');
  }
}
